import {Component, OnInit} from '@angular/core';
import { RoleService } from '../services/role.service';
import {RiskService} from './services/risk.service';
import {IdvCustomersService} from './services/idv-customers.service';
import {AddressCustomersService} from './services/address-customers.service';
import {BadgeService} from './services/badge.service';
import {PepCheckService} from './services/pep-check.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isCompliance = false;
  isMarketing = false;
  constructor(
    private roleService: RoleService,
    private riskService: RiskService,
    private idvCustomerService: IdvCustomersService,
    private addressCustomerService: AddressCustomersService,
    private badgeService: BadgeService,
    private pepCheckService: PepCheckService
  ) {

    badgeService.badgeEmitter$.subscribe(item => {

      if( item == 'compliance' ) {
this.refreshMarkers();
}

    });
  }

  showComplianceMarker = false;

  refreshMarkers(){

    // MS 2022-05-13 - agreed with anton last week to disable
    this.changeComplianceMarker(false);
    /*
    // Compliance
    try {
      if (!this.currentUserIsPartner() && !this.currentUserIsWallet()) {

        this.addressCustomerService.getActiveInquiries().subscribe(result => {

            if (!result || result == 0){

              this.riskService.getActiveInquiries().subscribe(result => {

                  if (!result || result == 0) {

                    this.idvCustomerService.getActiveInquiries().subscribe(result => {
                        if (!result || result == 0) {

                          this.pepCheckService.getActiveInquiries().subscribe(result => {
                              if (!result || result == 0) {
                                this.changeComplianceMarker(false);
                              }else{
                                this.changeComplianceMarker(true);
                              }
                            },
                            error => {

                            });


                        }else{
                          this.changeComplianceMarker(true);
                        }
                      },
                      error => {

                      });
                  }else{
                    this.changeComplianceMarker(true);
                  }

                },
                error => {});

            }else{
              this.changeComplianceMarker(true);
            }
          },
          error => {});
      }
    } catch (e) {
    }
    */
  }

  ngOnInit(): void {
    this.isCompliance = this.roleService.hasRoles('compliance');
    this.isMarketing = this.roleService.hasRoles('marketing');
    this.fillRouterLinks();
    this.refreshMarkers();
  }

  changeComplianceMarker(isVisible){
    const item = this.routerLinks.filter(x => x.id == 6)[0];
    if( item ) {
item.marker = isVisible;
}
  }

  fillRouterLinks() {
    this.routerLinks = [

      {
        id: 1,
        marker: false,
        link: '/orders',
        caption: 'Orders',
        visible: this.roleService.hasRoles(['admin', 'partner', 'partner_support', 'compliance', 'agent'])
      }, // "manager", "agent", "partner"
      {
        id: 2,
        marker: false,
        link: '/orders-cancellations-intern',
        caption: 'Cancellations',
        visible: this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner', 'partner_support', 'compliance'])
      },
      {
        id: 3,
        marker: false,
        link: '/invoices',
        caption: 'Invoices',
        visible: this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance', 'partner'])
      }, // "manager",          "partner"

      {
        id: 4,
        marker: false,
        link: '/loads',
        caption: 'Loads',
        visible: this.roleService.hasRoles(['admin', 'manager', 'compliance'])
      },
      {
        id: 1001,
        marker: false,
        link: '/loads/partner-wallet',
        caption: 'Wallet',
        visible: this.roleService.hasRoles(['partner', 'partner_support', 'wallet'])
      },

      {
        id: 5,
        marker: false,
        link: '/vouchers',
        caption: 'Vouchers',
        visible: this.roleService.hasRoles(['admin', 'partner', 'partner_support'])
      },

      {
        id: 6,
        marker: false,
        link: '/risk/check',
        caption: 'Compliance',
        visible: this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance', 'issuer_external'])
      },

      {id: 7, marker: false, link: '/cards', caption: 'Cards', visible: this.roleService.hasRoles(['admin','compliance', 'manager', ])}, // "manager", "agent", "partner"
      /*{id: 8, marker: false, link: '/customers', caption: 'Customers', visible: this.roleService.hasRoles(['admin',])}, // "manager", "agent", "partner"*/
      {
        id: 9,
        marker: false,
        link: '/customers-overview',
        caption: 'Customers',
        visible: this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner', 'partner_support', 'compliance', 'issuer_external'])
      }, // TODO: permissions anpassen

      // { link: "/idv-customers-overview", caption: "IDV"       , visible: this.roleService.hasRoles(["admin", "manager", "compliance" ]) }, // TODO: permissions anpassen
      // { link: "/address-customers-overview", caption: "Addresses"       , visible: this.roleService.hasRoles(["admin", "manager", "compliance" ]) }, // TODO: permissions anpassen

      {
        id: 10,
        marker: false,
        link: '/totalcard-orders',
        caption: 'Total Card',
        visible: this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance'])
      },
      /*{
        id: 11,
        marker: false,
        link: '/companies',
        caption: 'Companies',
        visible: this.roleService.hasRoles(['admin', 'partner', 'partner_support'])
      },*/
      {
        id: 12,
        marker: false,
        link: '/products',
        caption: 'Products',
        visible: this.roleService.hasRoles(['admin', 'partner', 'partner_support'])
      },
      {
        id: 13,
        marker: false,
        link: this.isCompliance || this.isMarketing ? '/administration/templates' : '/administration',
        caption: 'Administration',
        visible: this.roleService.hasRoles(['admin', 'compliance', 'marketing'])
      },
      {id: 14, marker: false, link: '/send-info', caption: 'Send', visible: this.roleService.hasRoles(['admin', 'marketing'])},
      // { link: "/reports"        , caption: "Reports"        , visible: this.roleService.hasRoles("admin") },


      // this is for the marketing user
      {
        id: 60,
        marker: false,
        link: '/marketing/stats',
        caption: 'Marketing',
        visible: this.roleService.hasRoles(['admin', 'marketing'])
      },

      // these are financial statistics for admins only
      {
        id: 61,
        marker: false,
        link: '/financial/dashboard',
        caption: 'Financial',
        visible: this.roleService.hasRoles(['super_admin'])
      },



      // this is for collection users
      {
        id: 70,
        marker: false,
        link: '/collection-search',
        caption: 'Case Search',
        visible: this.roleService.hasRoles(['collection_external'])
      }, // TODO: permissions anpassen


    ];

  }



  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  currentUserIsWallet(): boolean {
    return this.roleService.hasRoles('wallet');
  }




  public routerLinks = [];
}

